import { useTranslator } from "@eo-locale/react";

import { deleteMarker } from "@/redux/features/place-marker/thunk";
import { fetchPinDetails } from "@/redux/features/place-markers/thunk";
import { setView } from "@/redux/features/place-right-panel/slice";
import { setPinDetails } from "@/redux/features/place/slice";
import { fetchPlace } from "@/redux/features/place/thunk";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { AlertDialog, useToast } from "@/storybook-components";

const DeletePin = ({ actionParams, rightPanelProps, onClose, isOpen }: any) => {
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const toast = useToast({
    isClosable: true,
    containerStyle: {
      marginBottom: "1 !important"
    }
  });

  const { filteredCategoriesData } = useAppSelector(
    (state) => state.placeMarkersSlice
  );
  const { categories, isSelfPin } = filteredCategoriesData;
  const { id: userId } = useAppSelector(
    (state) => state.user.registeredUser.profile
  );
  const rightPanelView = useAppSelector(
    (state) => state.placesRightPanelView.view
  );
  const prevPageView = useAppSelector(
    (state) => state.placesRightPanelView.prevPageView
  );

  const closeAlert = () => {
    onClose();
  };

  const handleError = () => {
    if (!toast.isActive("places-toast")) {
      toast({
        id: "places-toast",
        title: translate("errors.sorrySomethingWentWrong"),
        status: "error"
      });
    }
  };

  const fetchPinDetailsWithSelectedData = () => {
    const { projectId, placesId } = actionParams;

    dispatch(
      fetchPinDetails({
        projectId,
        placesId,
        filters: {
          ...(isSelfPin && userId && { user_id: userId }),
          sort: { created_at: "desc" },
          category_id: categories
        }
      })
    );
  };

  const handleDeletePin = async () => {
    const { projectId, placesId, markerId } = actionParams;
    try {
      const res: any = await dispatch(
        deleteMarker({ projectId, placesId, markerId })
      );

      if (
        rightPanelView === "view-pin-details" &&
        prevPageView === "custom-marker"
      ) {
        rightPanelProps?.onClose();
      }

      dispatch(setView("activity-feed"));
      dispatch(setPinDetails({}));
      const responseStatus = res.payload?.status;
      if (responseStatus) {
        handleError();
        return;
      } else {
        fetchPinDetailsWithSelectedData();
      }
      if (!toast.isActive("places-delete-toast")) {
        // Refresh the responses count
        await dispatch(fetchPlace({ placesId, projectId }));
        toast({
          title: translate("places.pin.deletePinSuccess"),
          id: "places-delete-toast",
          status: "info"
        });
      }
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      handleError();
    }
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={closeAlert}
      header={translate("places.pin.deletePinHeader")}
      body={translate("places.pin.deletePinBody")}
      buttonPrimary={translate("common.delete")}
      buttonSecondary={translate("common.cancel")}
      buttonPrimaryVariant={"primary"}
      isPrimaryDestructive={true}
      buttonSecondaryVariant={"secondary"}
      isSecondaryDestructive={false}
      onPrimaryClickHandler={() => {
        handleDeletePin();
        closeAlert();
      }}
      onSecondaryClickHandler={closeAlert}
    />
  );
};

export default DeletePin;
